import React from 'react';

const PolitiqueConfidentialitePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Politique de confidentialité</h1>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Responsable du traitement</h2>
          <p className="text-gray-600">
            Les données collectées via ce site sont traitées par <strong>MRTP SARL</strong>, 5 Lot. Côte Meunière,
            04370 Villars-Colmars. Pour toute demande relative à vos données, contactez&nbsp;:
            <a href="mailto:Contact@artduchalet.com" className="text-[#c4d600] ml-1">Contact@artduchalet.com</a>.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Finalités</h2>
          <p className="text-gray-600">
            Nous utilisons vos informations pour répondre à vos demandes, établir des devis, assurer le suivi
            commercial et vous informer de nos actualités concernant la construction ou la rénovation de chalets.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Base légale</h2>
          <p className="text-gray-600">
            Les traitements reposent sur le consentement explicite (formulaire de contact, newsletter) et sur
            l&rsquo;exécution de mesures précontractuelles lorsque vous sollicitez une proposition commerciale.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Durée de conservation</h2>
          <p className="text-gray-600">
            Les données commerciales sont conservées pendant 3 ans à compter du dernier échange. Les documents
            contractuels sont archivés pendant la durée légale applicable (10 ans pour les pièces comptables).
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Droits des personnes</h2>
          <p className="text-gray-600">
            Conformément au RGPD, vous disposez d&rsquo;un droit d&rsquo;accès, de rectification, d&rsquo;effacement,
            d&rsquo;opposition et de portabilité. Exercez ces droits par email à
            <a href="mailto:Contact@artduchalet.com" className="text-[#c4d600] ml-1">Contact@artduchalet.com</a>.
            Nous répondrons sous 30 jours.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Sécurité</h2>
          <p className="text-gray-600">
            Nous mettons en œuvre des mesures techniques (hébergement sécurisé, chiffrement TLS) et organisationnelles
            afin de protéger vos données contre tout accès non autorisé.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialitePage;

